// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3R02Z","footer":"ModalUpdate_footer__2K-W1"};